exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.parity-good {\n    background-color: rgb(204,255,204);\n    border-color: solid 1px green;\n}\n.parity-partial {\n    background-color: rgb(255,255,204);\n    border: solid 1px yellow;\n}\n.parity-bad {\n    background-color: rgb(255,200,200);\n    border: solid 1px red;\n}\n", ""]);

// exports
